import { updateLink, getLinkById } from '@api/services/project-link.service';
import { useMutation, useQuery } from '@tanstack/react-query';
import * as Yup from 'yup';

const useLinkEditForm = (clientId: string, projectId: string, linkId: string) => {
    const { data: linkData, isLoading: isFetching } = useQuery(
        ['link', clientId, projectId, linkId],
        () => getLinkById(clientId, projectId, linkId),
        { enabled: !!linkId }
    );

    const updateLinkMutation = useMutation((payload: any) => updateLink(clientId, projectId, linkId, payload));

    const schema = Yup.object({
        name: Yup.string().trim().required('This field is required'),
        url: Yup.string().trim().required('This field is required'),
    });

    const initialValues: any = {
        name: linkData?.data.name || '',
        url: linkData?.data.url || '',
    };

    const submit = async (values: any) => {
        const data = await updateLinkMutation.mutateAsync(values);
        return data;
    };

    return {
        isFetching,
        isSubmitting: updateLinkMutation.isLoading,
        initialValues,
        schema,
        submit,
    };
};

export default useLinkEditForm;
